import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const CellContentWrapper = styled.div`
    display: flex;
    align-items: center;
    position: relative;
`;

export const TrafficSourceSpan = styled.span<{ $showMore: boolean; $hasChildren: boolean }>`
    position: ${({ $showMore }) => ($showMore ? "relative" : "static")};
    top: ${({ $showMore }) => ($showMore ? "-6px" : "auto")};
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;

    .ant-table-tbody .ant-table-row:hover &,
    .swTable-row:hover &,
    .swReactTable-row:hover &,
    tr:hover &,
    [class*="table-row"]:hover &,
    [class*="TableRow"]:hover & {
        margin-right: ${({ $hasChildren }) => ($hasChildren ? "10px" : "0px")};
    }
`;

export const FaviconImage = styled.img`
    width: 16px;
    height: 16px;
    margin-right: 4px;
    vertical-align: middle;
`;

export const InternalLink = styled.a`
    padding-left: 4px;
    min-width: 0;
    overflow: hidden;
`;

export const ContentDiv = styled.div`
    font-size: 14px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ChildrenCount = styled.span`
    margin-left: 4px;
    color: ${colorsPalettes.carbon[400]};
    font-size: 14px;
`;

export const ExternalLink = styled.a`
    opacity: 1;
    transition: opacity 300ms;
    display: inline-flex;
    align-items: center;
    color: ${colorsPalettes.carbon[300]};
    font-size: 12px;

    .SWReactIcons svg {
        width: 12px;
        height: 12px;
        > path {
            fill: ${colorsPalettes.carbon[300]};
        }
    }

    .ant-table-tbody .ant-table-row:hover &,
    .swTable-row:hover &,
    .swReactTable-row:hover &,
    tr:hover &,
    [class*="table-row"]:hover &,
    [class*="TableRow"]:hover & {
        opacity: 1;
    }

    .active-row &,
    .ant-table-tbody .ant-table-row-selected &,
    .swTable-row.active & {
        opacity: 1;
    }

    &:hover {
        opacity: 1;
    }
`;

export const HoverIconsContainer = styled.div`
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-40%);
    display: flex;
    align-items: center;
    gap: 4px;
    opacity: 0;
    transition: opacity 300ms;
    z-index: 10;

    .ant-table-tbody .ant-table-row:hover &,
    .swTable-row:hover &,
    .swReactTable-row:hover &,
    tr:hover &,
    [class*="table-row"]:hover &,
    [class*="TableRow"]:hover & {
        opacity: 1;
    }

    .active-row &,
    .ant-table-tbody .ant-table-row-selected &,
    .swTable-row.active & {
        opacity: 1;
    }

    &:hover {
        opacity: 1;
    }
`;

const CustomQualificationButton = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    .SWReactIcons svg {
        width: 28px;
        height: 28px;
    }
`;

export const Container = styled.div`
    .swTable-linkOut {
        opacity: 0 !important;
        transition: opacity 300ms;

        .ant-table-tbody .ant-table-row:hover &,
        .swTable-row:hover &,
        .swReactTable-row:hover &,
        tr:hover &,
        [class*="table-row"]:hover &,
        [class*="TableRow"]:hover & {
            opacity: 1 !important;
        }

        .active-row &,
        .ant-table-tbody .ant-table-row-selected &,
        .swTable-row.active & {
            opacity: 1 !important;
        }

        &:hover {
            opacity: 1 !important;
        }
    }
`;
